module.exports = __webpack_public_path__ + "img/ispr_is1024_text.9076374f.png";